import React from 'react';

const ChatCustomIntro = (props) => {
  const _start = () => {
    //console.log(props);
    props.actions._introStart();
  };
  return (
    <div className="intro-container">
      <div className="intro-div">
        <img src="/img/icon_chatbot.png" />
      </div>
      <div className="intro-div2">
        <h2>애니플러스 챗봇</h2>
        <div>고객센터: 070-7162-7013</div>
        <div>운영시간: 10:00 ~ 18:00</div>
        <div>webmaster@aniplustv.com</div>
      </div>

      <div className="intro-div3">
        <div className="q-btn" onClick={_start}>
          문의 시작하기
        </div>
      </div>
      <div className="intro-div4"></div>
    </div>
  );
};

export default ChatCustomIntro;
